export default function getPackageUniqueKey(packageType, hotelId, index, uniqueKeyHelp) {
  if (uniqueKeyHelp) {
    return `${packageType}-${uniqueKeyHelp}-${index}-hotel-${hotelId}`;
  }

  return `${packageType}-${index}-hotel-${hotelId}`;
}
